import React from "react";
import View from "common/View";
import DateTimeList from "./DateTimeList";
import TimeZoneModal from "./TimeZoneModal";
import TimeModal from "./TimeModal";
import DateModal from "./DateModal";

export const DateAndTimeAdmin = ({returnView}) => (
  <View className="container-lg" title="System Date & Time" refresh={null} returnView={returnView}>
    <DateTimeList />
    <TimeZoneModal />
    <TimeModal />
    <DateModal />
  </View>
);

export default DateAndTimeAdmin;
